export default {
    navbar: {
        home: "मुखपृष्ठ",
        roles: "भूमिका",
        features: "वैशिष्ट्ये",
        whyUs: "आम्हाला का",
        contactUs: "आमच्याशी संपर्क साधा",
    },
    home: {
        TeachWings: "टीचविंग्ज",
        comprehensive: "व्यापक",
        modules: "मॉड्यूल",
        for: "साठी",
        schoolManagement: "शाळा व्यवस्थापन अ‍ॅप",
        customized: "सानुकूलित",
        userAcees: "वापरकर्ता प्रवेश",
        heading_01: "यासह उंच उडवा",
        how: "कसे",
        works: "कामे",
        why_choose: "का निवडावे",
        sub_heading_01: "सहज शाळा व्यवस्थापन.",
        heading_02: "तुमच्या शाळेच्या सर्व गरजांसाठी एक एकीकृत तंत्रज्ञान भागीदार",

        para_01:
            "टीचविंग्ज, सर्वसमावेशक शाळा व्यवस्थापन उपाय वापरून तुमच्या शाळेच्या कार्यपद्धतीत क्रांती घडवा. विद्यार्थी, पालक, शिक्षक आणि प्रशासकांच्या गरजा पूर्ण करण्यासाठी डिझाइन केलेले, टीचविंग्ज संप्रेषण, शिक्षण आणि प्रशासकीय कामे सुलभ करते, ज्यामुळे शाळेचे कामकाज अधिक कार्यक्षम, पारदर्शक आणि सुरक्षित बनते.",
        heading_03: "टीचविंग्ज बद्दल",
        superAdmin: "सुपर अ‍ॅडमिन",
        admin: "प्रशासन",
        receptionist: "रिसेप्शनिस्ट",
        librarian: "ग्रंथपाल",
        classTeacher: "वर्ग शिक्षक",
        teacher: "शिक्षक",
        student: "विद्यार्थी",
        parent: "पालक",
        heading_04: "टीचविंग्ज बद्दल",
        para_03:
            "टीचविंग्जची स्थापना शाळा व्यवस्थापन सुलभ करण्याच्या आणि सर्व भागधारकांना सक्षम करण्याच्या दृष्टिकोनातून केली गेली आहे - विद्यार्थी, पालक, शिक्षक आणि प्रशासक. आमचे ध्येय एक सुरक्षित, अंतर्ज्ञानी व्यासपीठ प्रदान करणे आहे जे संवाद सुलभ करते, शिक्षण वाढवते आणि प्रशासकीय कामे स्वयंचलित करते. टीचविंग्जसह, आम्ही जगभरातील शाळांना शैक्षणिक परिणाम सुधारणारी, प्रशासकीय ओझे कमी करणारी आणि सहयोगी वातावरण निर्माण करणारी तंत्रज्ञान स्वीकारण्यास मदत करत आहोत. चला टीचविंग्जसह उड्डाण करूया आणि वेळ वाचवूया.",
        heading_05: "टीचविंग्जची प्रमुख वैशिष्ट्ये",

        card_heading_01: "प्रशासक",
        card_heading_02: "शिक्षक",
        card_heading_03: "विद्यार्थी",
        card_heading_04: "पालक",

        card_para_01:
            "प्रवेश प्रक्रिया सुलभ करा, वापरकर्ते, वेळापत्रक, शुल्क, वाहतूक व्यवस्थापित करा आणि कार्यक्षम ऑपरेशन्स आणि माहितीपूर्ण निर्णयांसाठी अंतर्दृष्टीपूर्ण अहवाल तयार करा.",
        card_para_02:
            "वर्ग व्यवस्थापित करा, कामगिरीचा मागोवा घ्या, ग्रेड द्या आणि प्रभावीपणे सहभागी व्हा.",
        card_para_03:
            "ग्रेड, वेळापत्रक, असाइनमेंट, परीक्षा आणि संसाधने सहजतेने मिळवा.",
        card_para_04:
            "प्रगती, उपस्थिती, शुल्क याबद्दल अपडेट रहा आणि अखंडपणे संवाद साधा.",

        keyFeatures: {
            list_01:
                "व्यापक वापरकर्ता व्यवस्थापन: भूमिका आणि परवानग्यांवर पूर्ण नियंत्रण ठेवून शिक्षक, विद्यार्थी, कर्मचारी आणि पालकांचे व्यवस्थापन करा.",
            list_02: "नवीन प्रवेश आणि शैक्षणिक सत्र व्यवस्थापन",
            list_03:
                "वेळापत्रके तयार करा आणि अपडेट करा: वर्ग वेळापत्रक, परीक्षा आणि शाळेतील कार्यक्रम सहजपणे सेट करा.",
            list_04:
                "फी आणि आर्थिक व्यवस्थापन: शाळेच्या आर्थिक बाबींवर लक्ष ठेवा, फी संरचना व्यवस्थापित करा आणि देयकांचा कार्यक्षमतेने मागोवा घ्या.",
            list_05:
                "वाहतूक व्यवस्थापन: वाहतूक व्यवस्थापन विद्यार्थ्यांच्या वाहतुकीसाठी बसेसचे सुरक्षित, कार्यक्षम मार्ग, ट्रॅकिंग आणि वेळापत्रक सुनिश्चित करते आणि त्याचबरोबर अनुपालन आणि सुरक्षितता राखते.",
            list_06:
                "डेटा-चालित अहवाल: उपस्थिती, कामगिरी, वित्त आणि बरेच काही यावर तपशीलवार अहवाल आणि विश्लेषणे तयार करा.",
            list_07:
                "वर्ग आणि असाइनमेंट व्यवस्थापित करा: वर्ग, असाइनमेंट आणि धडे योजना एकाच ठिकाणी आयोजित करा.",
            list_08: "उपस्थिती व्यवस्थापन: वर्ग उपस्थिती नोंदी आणि ट्रॅकिंग.",
            list_09:
                "विद्यार्थ्यांच्या प्रगतीचे निरीक्षण करा: वैयक्तिक विद्यार्थ्यांची कामगिरी पहा आणि त्यांचा मागोवा घ्या आणि वेळेवर अभिप्राय द्या.",
            list_10:
                "ग्रेड बुक आणि रिपोर्ट कार्ड: लवकर ग्रेड एंटर करा, रिपोर्ट कार्ड तयार करा आणि विद्यार्थ्यांच्या कामगिरीचे मूल्यांकन करा.",
            list_11:
                "संप्रेषण साधने: बिल्ट-इन मेसेजिंग सिस्टमद्वारे विद्यार्थी आणि पालकांशी थेट संवाद साधा.",
            list_12:
                "ग्रेड/गुण आणि रिपोर्ट कार्ड ट्रॅक करा: तुमचे ग्रेड/गुण, असाइनमेंट आणि कामगिरी अपडेट्स त्वरित मिळवा.",
            list_13:
                "वेळापत्रक आणि वेळापत्रक पहा: तुमच्या वैयक्तिकृत वेळापत्रकासह आणि आगामी कार्यक्रमांसह कधीही वर्ग चुकवू नका.",
            list_14:
                "गृहपाठ आणि असाइनमेंट्स: देय तारखा आणि सबमिशन रिमाइंडर्ससह तुमचे गृहपाठ आणि असाइनमेंट सहजपणे पहा आणि व्यवस्थापित करा.",
            list_15:
                "परीक्षेचे अपडेट्स आणि निकाल: परीक्षेच्या वेळापत्रकांबाबत अद्ययावत रहा आणि निकाल उपलब्ध होताच मिळवा.",
            list_16:
                "शिक्षण संसाधने: शिक्षकांकडून कधीही, कुठेही डिजिटल अभ्यास साहित्य, धडे योजना आणि नोट्स मिळवा.",
            list_17:
                "ग्रेड/गुण आणि रिपोर्ट कार्ड ट्रॅक करा: तुमचे ग्रेड/गुण, असाइनमेंट आणि कामगिरी अपडेट्स त्वरित मिळवा.",
            list_18:
                "वेळापत्रक आणि वेळापत्रक पहा: तुमच्या वैयक्तिकृत वेळापत्रकासह आणि आगामी कार्यक्रमांसह कधीही वर्ग चुकवू नका.",
            list_19:
                "गृहपाठ आणि असाइनमेंट्स: देय तारखा आणि सबमिशन रिमाइंडर्ससह तुमचे गृहपाठ आणि असाइनमेंट सहजपणे पहा आणि व्यवस्थापित करा.",
            list_20:
                "परीक्षेचे अपडेट्स आणि निकाल: परीक्षेच्या वेळापत्रकांबाबत अद्ययावत रहा आणि निकाल उपलब्ध होताच मिळवा.",
            list_21:
                "शिक्षण संसाधने: शिक्षकांकडून कधीही, कुठेही डिजिटल अभ्यास साहित्य, धडे योजना आणि नोट्स मिळवा.",
        },

        heading_06: "टीचविंग्ज कसे काम करते.",
        card_heading_05: "साइन अप करा",
        card_heading_06: "तुमचा प्रोफाइल सेट करा",
        card_heading_07: "वैशिष्ट्ये वापरणे सुरू करा",
        card_heading_08: "कनेक्टेड रहा",
        card_para_05: "तुमच्या शाळेची नोंदणी करा आणि सबस्क्रिप्शन निवडा.",
        card_para_06:
            "तुमचा डॅशबोर्ड वैयक्तिकृत करा आणि तुमच्या भूमिकेनुसार आणि प्राधान्यांनुसार सेटिंग्ज कॉन्फिगर करा.",
        card_para_07:
            "सर्व प्रमुख वैशिष्ट्यांचे ग्रेड, असाइनमेंट, कम्युनिकेशन टूल्स, वेळापत्रके आणि बरेच काही लगेच अॅक्सेस करा.",
        card_para_08:
            "ग्रेड, उपस्थिती आणि शाळेच्या बातम्यांबद्दल रिअल-टाइम अपडेट्स मिळवा. शिक्षक आणि पालकांशी थेट संपर्क साधा, हे सर्व अॅपमध्येच.",
        heading_07: "टीचविंग्ज का निवडावे?",
        whyChoose: {
            list_01:
                "सुव्यवस्थित शालेय कामकाज: एकाच, वापरण्यास सोप्या प्लॅटफॉर्मवर वर्ग वेळापत्रक आणि उपस्थितीपासून ते ग्रेड आणि फीपर्यंत सर्वकाही व्यवस्थापित करा.",
            list_02:
                "सुधारित संप्रेषण: सर्व वापरकर्त्यांसाठी रिअल-टाइम सूचना, थेट संदेशन आणि त्वरित अद्यतनांसह माहितीपूर्ण रहा.",
            list_03:
                "वेळेची बचत करणारे ऑटोमेशन: ग्रेडिंग, उपस्थिती ट्रॅकिंग आणि फी रिमाइंडर्स यासारखी कामे स्वयंचलित करा, ज्यामुळे तुम्हाला खरोखर महत्त्वाच्या गोष्टींवर लक्ष केंद्रित करता येईल - शिक्षण.",
            list_04:
                "सुरक्षित आणि खाजगी: तुमचा डेटा आमच्याकडे सुरक्षित आहे. टीचविंग्ज डेटा संरक्षण आणि गोपनीयतेच्या सर्वोच्च मानकांचे पालन करते.",
            list_05:
                "तुमच्या शाळेसाठी सानुकूल करण्यायोग्य: लवचिक वैशिष्ट्ये आणि सेटिंग्जसह तुमच्या शाळेच्या अद्वितीय गरजा पूर्ण करण्यासाठी प्लॅटफॉर्म तयार करा.",
        },
        para_04: "सहज शाळा व्यवस्थापन.",
    },
    keyFeatures: {
        heading: {
            w1: "महत्वाची वैशिष्टे",
            w2: "टीचविंग्जचे",
        },
        adminFeat: {
            h1: "प्रशासक",
        },
        teacherFeat: {
            h1: "शिक्षक",
        },
        studentFeat: {
            h1: "विद्यार्थी",
        },
        parentFeat: {
            h1: "पालक",
        },
    },
    contactUs: {
        heading_01: "आम्हाला संदेश द्या किंवा ईमेल पाठवा",
        name: "नाव",
        email: "ईमेल",
        contactNumber: "संपर्क क्रमांक",
        message: "संदेश",
        cancel: "रद्द करा",
        submit: "सबमिट करा",
    },
    readMore: {},
    common: {
        getStarted: "सुरुवात करा",
        and: "आणि",
        registerNow: "आत्ताच नोंदणी करा",
        loginNow: "आता लॉगिन करा",
        knowMore: "अधिक जाणून घ्या",
        learnMore: "अधिक जाणून घ्या",
    },

    footer: {
        availableOn: "रोजी उपलब्ध",
        contactEnquiry: "संपर्क / चौकशी",
        navigate: "नेव्हिगेट करा",
        usefullLinks: "उपयुक्त दुवे",
        footer_para:
            "काही प्रश्न आहेत किंवा मदत हवी आहे? डेमो किंवा अधिक माहितीसाठी आमच्याशी संपर्क साधा.",
        allRightsReserved: "सर्व हक्क राखीव.",
        playStore: "प्ले स्टोअर",
        home: "मुखपृष्ठ",
        roles: "भूमिका",
        features: "वैशिष्ट्ये",
        whyUs: "आम्हाला का",
        contactUs: "आमच्याशी संपर्क साधा",
        appStore: "अ‍ॅप स्टोअर",
        register: "नोंदणी करा",
        login: "लॉगिन करा",
    },
    privacy: {
        h1: "गोपनीयता धोरण",
    },
}